import { render, staticRenderFns } from "./app_show_data_supply_list.vue?vue&type=template&id=0ad36f47&scoped=true&"
import script from "./app_show_data_supply_list.vue?vue&type=script&lang=js&"
export * from "./app_show_data_supply_list.vue?vue&type=script&lang=js&"
import style0 from "./app_show_data_supply_list.vue?vue&type=style&index=0&id=0ad36f47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad36f47",
  null
  
)

export default component.exports